import React, { useState } from 'react';
import { post } from '../../../model/post';
import { StyledComponentProps } from '@material-ui/core/styles';
import Prompt from '../../../ui-components/Dialog/Prompt';
import Button from '../../../ui-components/Button/SendIconButton';
import { Tooltip } from '@material-ui/core';
//import Button from '../../../ui-components/Button/EditButton';
interface IProps extends StyledComponentProps {
    post: post;
    deliverPost: (post: post) => void;
}

export const SendButton = (props: IProps) => {
    const [open, setOpen] = useState(false);
    const handleConfirmSend = () => {
        let altered = props.post
        altered.delivered = true
        altered.deliveryDate = new Date()
        props.deliverPost(altered)
    }

    return (
        <>
            <Tooltip title='Pubblica'>
                <Button onClick={() => setOpen(true)}>Invia</Button>
            </Tooltip>
            <Prompt open={open}
                onCancel={() => setOpen(false)}
                onConfirm={handleConfirmSend}
                confirmText='Pubblica'
                cancelText='Annulla'
                icon='publish'
                text='Sei sicuro di voler pubblicare il post?'>
            </Prompt>
        </>
    );
}
